import React from 'react';
import { Box } from 'native-base';
import LoanStatusTracker from './index';
import { useStatusTrackerQuery } from '../../../../loaninprogress/hooks/TrackingItems';
import LoanStatusTrackerSkelton from './LoanStatusTrackerSkelton';
const LoanStatusContainer = props => {
  return /*#__PURE__*/React.createElement(Container, props);
};
const Container = props => {
  const {
    selfServUrl,
    authToken,
    loanNumber,
    xApiKey
  } = props;
  const {
    isSuccess,
    isLoading,
    data
  } = useStatusTrackerQuery({
    authToken,
    selfServUrl,
    xApiKey,
    loanNumber
  });
  if (isLoading) return /*#__PURE__*/React.createElement(LoanStatusTrackerSkelton, {
    dataTestID: 'loan-status-tracker-skeleton'
  });
  return isSuccess && data ? /*#__PURE__*/React.createElement(LoanStatusTracker, {
    loanTrackingData: data?.tracker
  }) : /*#__PURE__*/React.createElement(Box, {
    testID: "loan-status-tracker-error-box"
  });
};
export default /*#__PURE__*/React.memo(LoanStatusContainer);
//# sourceMappingURL=LoanStatusContainer.js.map